var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileWhite = function SvgFileWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0H4.125A1.12 1.12 0 0 0 3 1.12v21.755A1.12 1.12 0 0 0 4.12 24h15.755A1.123 1.123 0 0 0 21 22.88V6h-5.25a.75.75 0 0 1-.75-.75z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 5.714V6h-5.25a.75.75 0 0 1-.75-.75V0h.286a1.13 1.13 0 0 1 .797.328l4.589 4.594a1.12 1.12 0 0 1 .328.792"
  }))));
};
export default SvgFileWhite;